<template>
  <div>
    <!-- <div :id="mapContainerId" style="width: 100%; height: 300px;"></div> -->
    <div class="flight-summary-container">
      <h1>
        Safety Score: 
        <span :style="{ color: $global.scoreColor(progressColors, score) }">{{ score }}%</span>
      </h1>
      <div class="progressbar-container">
        <div class="progressbar">
          <div class="progress-item" :style="{ width: score + '%' }"></div>
        </div>
        <img src="/static/img/caret-up.svg" class="caret-up" :style="{ left: `calc(${score}% - 10px)` }">
      </div>
    </div>
    
    <div class="grid gap-sm1 summary-container" :style="$global.dynamicCols(3)">
      <div class="grid-form">
        <div class="grid-label">Pilot 1</div>
        <input type="text" v-model="form.pilot1" placeholder="Pilot 1...">
      </div>
      <div class="grid-form">
        <div class="grid-label">Pilot 2</div>
        <input type="text" v-model="form.pilot2" placeholder="Pilot 2...">
      </div>
      <div class="grid-form">
        <div class="grid-label">Aircraft</div>
        <input type="text" v-model="form.aircraft" placeholder="Aircraft...">
      </div>
    </div>

    <div class="grid gap-sm1 summary-container" :style="$global.dynamicCols(3)">
      <div class="grid-form">
        <div class="grid-label">Start Time</div>
        <input type="text" v-model="form.startTime" placeholder="Start Time...">
      </div>
      <div class="grid-form">
        <div class="grid-label">Duration</div>
        <input type="text" v-model="form.duration" placeholder="Duration...">
      </div>
      <div class="grid-form">
        <div class="grid-label">Distance</div>
        <input type="text" v-model="form.distance" placeholder="Distance...">
      </div>
    </div>

    <div class="mt-4">
      <img src="/static/img/map-image.svg" style="width: 100%;">
    </div>

    <div class="common-section-content">
      <div class="header-text-info mt-4">Past incidents or accidents on your flight path</div>
      <br>
      <div class="common-section-flex gap-sm1" v-for="incident in 3" :key="incident">
        <input type="checkbox" :id="`incident${incident}`" v-model="form[`incident${incident}`]">
        <label :for="`incident${incident}`" class="incidentClass">Example of an accident that took place pulled from the NTSB</label>
      </div>
    </div>

    <div class="summary-actions">
      <button class="primary btn-edit">Edit</button>
      <button class="primary">Done</button>
    </div>
  </div>
</template>

<script>
import { progressColors } from '../../util/constants.js';

export default {
  data() {
    return {
      score: 20,
      progressColors,
      form: {
        pilot1: 'Keaton Harris',
        pilot2: 'Tyler Johnson',
        aircraft: 'N2361R',
        startTime: '07:00',
        duration: '1 Hr 1 Min',
        distance: '63 nm',
        incident1: true
      }
    };
  },
  // mounted() {
  //   this.loadSkyVectorScript();
  // },
  // methods: {
  //   loadSkyVectorScript() {
  //     if (!document.getElementById("skyvector-script")) {
  //       const script = document.createElement("script");
  //       script.src = this.skyVectorScriptUrl;
  //       script.type = "text/javascript";
  //       script.id = "skyvector-script";
  //       document.body.appendChild(script);
  //     }
  //   },
  // },
};
</script>

<style>
.flight-summary-container h1 {
  line-height: 1.2;
  margin: 30px 0;
  font-size: 60px;
  font-weight: bold;
  color: #404040;
}

.progressbar-container {
  position: relative;
  width: 100%;
  margin-top: 20px;
}

.progressbar {
  background: linear-gradient(to right, 
    #FE0D02 0%, 
    #FC5B00 13%, 
    #FFA000 25%, 
    #FDD900 38%, 
    #FDF102 50%, 
    #D8FF02 63%, 
    #9FFF02 75%, 
    #5CFD01 88%, 
    #13FF02 100%
  );
  width: 100%;
  height: 10px;
  border-radius: 50px;
  position: relative;
}

.progress-item {
  height: 100%;
  border-radius: 50px;
  transition: width 0.5s ease-in-out;
}

.caret-up {
  position: absolute;
  top: 15px;
  width: 20px;
  height: 20px;
  transform: translateX(-50%);
}

.summary-actions {
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.btn-edit {
  background: #9f9f9f;
}

.summary-container {
  margin-top: 50px;
}
.summary-container .grid-label {
  font-size: 13px;
  color: #717171;
}

.header-row {
  font-weight: bold;
  color: #404040;
}
.common-section-content input[type="checkbox"] {
  width: fit-content !important;
  margin-top: 4px;
}
.common-section-content label {
  margin-top: 3px;
  color: #404040;
}
.common-section-flex {
  display: flex;
  margin-bottom: 10px;
}
</style>
